// const baseURL = "http://cd-prod-alb-ue1-600904582.us-east-1.elb.amazonaws.com";
// const baseURL = "http://cd-dev-alb-ue1-1301524723.us-east-1.elb.amazonaws.com/";
const baseURL = "https://cdapi.characterdaily.com";

const stripeKey =
  "pk_test_51HKVbRLkFH9RkPtnGlr5zupK0IxIhGVUBy6lRRvMP5X5vd3QDk3ENR8IwROBAa1ssEuLDCzdo40Nr6IxcLrT3kCJ009yeT8lYE";

const firebasePublicKey =
  "BOLcxJiaJNTXEIt9gAUjpAk8SAjwxUV2y_5wo8gIaqiVaaUTQigox2VblKEvJzUxGo79sE15dHbCLZLyk8PEoUQ";

export { baseURL, stripeKey, firebasePublicKey };
